var swiperSlider = function (root) {
	var me = this;
	me.root = $(root);

	var _init = function (element) {
			$element = element;
			initEvents();
		},
		initEvents = function () {
            $target = $element.attr('data-swiper-target')

            if ($element.hasClass('js-swiper-swipe-tiles') || $element.hasClass('js-swiper-promo-tile-slider')) {
                var swipeTilesEl = document.querySelector($target);
                if (swipeTilesEl) {
                    var isPromoTileSlider = $element.hasClass('js-swiper-promo-tile-slider');
                    var promoPag = swipeTilesEl.querySelector(
                        ".promo-tile-slider__pagination"
                    );
                    var promoDesktopMq = window.matchMedia('(min-width: 768px)');
                    var swipeTilesSwiper = new Swiper(swipeTilesEl, {
                        slidesPerView: "auto",
                        spaceBetween: 15,
                        enabled: !isPromoTileSlider || promoDesktopMq.matches,
                        pagination: promoPag
                            ? { el: promoPag, clickable: true }
                            : false,
                    });
                    if (isPromoTileSlider) {
                        promoDesktopMq.addEventListener('change', function (event) {
                            if (event.matches) {
                                swipeTilesSwiper.enable();
                                swipeTilesSwiper.update();
                            } else {
                                swipeTilesSwiper.disable();
                            }
                        });
                    }
                }
                return;
            }

            switch ($target) {
                case '.js-swiper-marquee-feature':
                    var swiper = new Swiper($target, {
                        spaceBetween: 15,
                        centeredSlides: false,
                        speed: 10000,
                        loop: true,
                        autoplay: {
                            delay: 0,
                        },
                        slidesPerView:'auto',
                        allowTouchMove: true,
                        disableOnInteraction: false
                    });

                    break;
                default:
                    var swiper = new Swiper($target, {
                        slidesPerView: "auto",
                        spaceBetween: 15,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true,
                        },
                    });
                    break;
            }
		};

	me.root.each(function () {
		new _init($(this));
	});
};

$(document).ready(function () {
	new swiperSlider(".js-swiper-slider");
});
